/**
 * Публичные ручки чатов, вызовы которых диагностируются
 */
export enum EPublicApiEndpoint {
  ChatsGet = '/v3/web/chats/get/',
  ChatsSync = '/v3/web/chats/sync/',
  HistoryMessages = '/v3/web/history/messages/',
}

/**
 * Источник запроса к публичной ручке чатов
 */
export enum ERequestSource {
  /** Источник не проставлен на вызывающей стороне */
  Unknown = 'unknown',
  /** Реконнект WS после разрыва соединения */
  WsReconnectSocketClose = 'wsReconnect:socketClose',
  /** Реконнект WS при возврате на вкладку */
  WsReconnectTabFocus = 'wsReconnect:tabFocus',
  /** Реконнект WS по кнопке «Повторить» в окне ошибки */
  WsReconnectRetryButton = 'wsReconnect:retryButton',
  /** Реконнект WS перед отправкой сообщения */
  WsReconnectSendMessage = 'wsReconnect:sendMessage',
  /** Реконнект WS перед отправкой ответа на сообщение */
  WsReconnectSendAnswer = 'wsReconnect:sendAnswer',
  /** Реконнект WS перед подпиской на статус собеседника */
  WsReconnectSubscribeStatus = 'wsReconnect:subscribeStatus',
  /** Реконнект WS перед отпиской от статуса собеседника */
  WsReconnectUnsubscribeStatus = 'wsReconnect:unsubscribeStatus',
  /** Открытие чата */
  MessagesChatOpen = 'messages:chatOpen',
  /** Подгрузка предыдущих сообщений по скроллу */
  MessagesNextPage = 'messages:nextPage',
  /** Переход к цитируемому сообщению по клику на реплай */
  MessagesReplyScroll = 'messages:replyScroll',
  /** Синхронизация сообщений открытого чата */
  MessagesSync = 'messages:sync',
  /** Подготовка состояния на сервере */
  Ssr = 'ssr',
}

/**
 * Раздел списка чатов, за которым идёт запрос
 */
export enum EChatListSection {
  Messages = 'messages',
  Unread = 'unread',
  Spam = 'spam',
  Archive = 'archive',
  Starred = 'starred',
}

/**
 * Действие, вызвавшее запрос списка чатов
 */
export enum EChatListTrigger {
  /** Триггер не проставлен на вызывающей стороне */
  Unknown = 'unknown',
  /** Первая загрузка списка при монтировании */
  FirstLoad = 'firstLoad',
  /** Подгрузка следующей страницы по скроллу */
  NextPage = 'nextPage',
  /** Переключение раздела в верхнем меню */
  RouteChange = 'routeChange',
  /** Переключение мастер-вкладок */
  MasterTabChange = 'masterTabChange',
  /** Полная перезагрузка после ошибки синхронизации tooManyRecords */
  SyncOverflow = 'syncOverflow',
}

/**
 * Источник запроса списка чатов: раздел + вызвавшее действие
 */
export type TChatListSource = `chatList:${EChatListSection}:${EChatListTrigger}`;

/**
 * Источник любого запроса к публичным ручкам чатов
 */
export type TRequestSource = ERequestSource | TChatListSource;

/**
 * Условия, в которых выполняется запрос
 */
export type TRequestDiagnostics = Record<string, string | number | boolean | null>;
